import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Empty } from 'antd';
import styled from 'styled-components';
import { isEmpty, result, toLower } from 'lodash';
import ComponentsMap from '../ComponentsMap';
import PartySection from './PartySection';
import { DEFAULT_MAP_NAMESPACE, DEFAULT_CUSTOMER_TYPE } from './constants';
import { getGlobalSettings, genarateRendererConfigs } from '../utils';
import Wait4Me from '../../../components/Wait4Me';

const PartyIdentityPanel = styled.div`
  background: #335777;
  border-radius: 5px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
`;

const LoadingWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AlertDetailPartyIdentity = ({
  apiActions,
  settings,
  gsQuery,
  alertPartyIdentity,
  alertId,
  isLoading,
  error,
  mapNamespace = DEFAULT_MAP_NAMESPACE,
  gridMinColumn,
  getCustomerID
}) => {
  const [dataSource, setDataSource] = useState(null);
  const [showComponent, setShowComponent] = useState(true);
  const { getAMLSCommonAlertPartyIdentity } = apiActions;

  useEffect(() => {
    if (dataSource) {
      sendCustomerId(dataSource);
    }
  }, [dataSource]);

  const sendCustomerId = (dataSource) => {
    let customerId = '';
    dataSource?.forEach((data) => {
      data.forEach((record) => {
        if (record.itemName === 'partyKey') {
          customerId = record.itemValue;
        }
      });
    });
    getCustomerID(customerId);
  };

  useEffect(() => {
    setDataSource(null);
    getAMLSCommonAlertPartyIdentity({ alertId });
  }, [alertId]);

  useEffect(() => {
    if (!isEmpty(alertPartyIdentity) && settings) {
      const { customerType = DEFAULT_CUSTOMER_TYPE } = alertPartyIdentity;
      const { widgetConfig, isVisible } =
        getGlobalSettings({
          settings,
          gsQuery: gsQuery[toLower(customerType)]
        }) || {};

      if (!isVisible || isEmpty(widgetConfig)) {
        setShowComponent(false);
        return true;
      } else if (!showComponent) {
        setShowComponent(true);
      }

      setDataSource(
        genarateRendererConfigs({
          data: alertPartyIdentity,
          settings: widgetConfig,
          configs: result(ComponentsMap, mapNamespace) || {}
        })
      );
    }
  }, [alertPartyIdentity, settings]);

  return (
    <>
      {showComponent ? (
        <PartyIdentityPanel>
          {isLoading && (
            <LoadingWrapper>
              <Wait4Me />
            </LoadingWrapper>
          )}
          {dataSource && (
            <PartySection
              dataSource={dataSource}
              gridMinColumn={gridMinColumn}
            />
          )}
          {error && <Empty />}
        </PartyIdentityPanel>
      ) : null}
    </>
  );
};

AlertDetailPartyIdentity.propTypes = {
  apiActions: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  gsQuery: PropTypes.object.isRequired,
  alertPartyIdentity: PropTypes.object,
  alertId: PropTypes.string.isRequired,
  error: PropTypes.object,
  gridMinColumn: PropTypes.number,
  mapNamespace: PropTypes.string
};

export default AlertDetailPartyIdentity;
